import { useTranslation } from 'next-i18next'

import requireImages from '@/utils/require-images'

import { Description, Image, ImageCard, Text } from './elements'

const images = requireImages(['chat'], {
  requireFn: (path: string) => require(`./images/${path}`),
  extensions: ['png']
})

const RentalRecord = ({ breakpoint }: { breakpoint: string }) => {
  const { t } = useTranslation('renters')
  const image: Image = images.chat[0]

  return (
    <ImageCard breakpoint={breakpoint} image={image}>
      <Text>{t(`renters:It's all here`)}</Text>
      <Description breakpoint={breakpoint} maxWidth="230px">
        {t(
          'renters:Streamlined communication lives in our centralized inbox where you can chat, apply, and sign for your next home all in one place.'
        )}
      </Description>
    </ImageCard>
  )
}

export default RentalRecord
